import { StaticImageData } from 'next/image';

import ajudaCusto from '@/public/icons/ajuda-custo.png';
import aposentadoria from '@/public/icons/aposentadoria.png';
import odonto from '@/public/icons/assistencia-odontologica.png';
import bebeMovel from '@/public/icons/bebe-movel.png';
import bombaCombustivel from '@/public/icons/bomba-de-combustivel.png';
import carro from '@/public/icons/carro.png';
import cestaDeCompras from '@/public/icons/cesta-de-compras.png';
import comissao from '@/public/icons/comissao.png';
import creche from '@/public/icons/creche.png';
import descontos from '@/public/icons/descontos.png';
import educacaoOnline from '@/public/icons/educacao-online.png';
import estacionamento from '@/public/icons/estacionamento.png';
import estetoscopio from '@/public/icons/estetoscopio.png';
import exercicio from '@/public/icons/exercicio.png';
import lucros from '@/public/icons/lucros.png';
import planoDeCarreira from '@/public/icons/plano-de-carreira.png';
import premio from '@/public/icons/premio.png';
import refeicao from '@/public/icons/refeicao.png';
import seguroDeVida from '@/public/icons/seguro-de-vida.png';
import celular from '@/public/icons/smartphone.png';
import transporte from '@/public/icons/transporte.png';

const iconMap: { [key: string]: StaticImageData } = {
  'Ajuda de custo': ajudaCusto,
  'Assistência Médica': estetoscopio,
  'Assistência Odontológica': odonto,
  'Auxílio Combustível': bombaCombustivel,
  'Auxílio Creche': creche,
  'Auxílio Educação': educacaoOnline,
  'Carro fornecido pela empresa': carro,
  'Celular fornecido pela empresa': celular,
  'Cesta básica': cestaDeCompras,
  Comissão: comissao,
  'Convênio Universitário': educacaoOnline,
  'Convênios Comerciais': descontos,
  'Descontos Comerciais': descontos,
  'Enxoval do Bebê': bebeMovel,
  Estacionamento: estacionamento,
  'Ginástica Laboral': exercicio,
  // 'Hora Extra': ``,
  'Plano de Carreira': planoDeCarreira,
  PLR: lucros,
  Premiação: premio,
  'Previdência Privada': aposentadoria,
  'Refeição no local': refeicao,
  'Seguro de vida': seguroDeVida,
  'Transporte fornecido pela empresa': transporte,
  'Vale Alimentação': cestaDeCompras,
  'Vale Refeição': refeicao,
  'Vale Transporte': transporte,
};

export function getBenefitIcon(benefit: string) {
  return iconMap[benefit];
}
